import React from "react";
import AddBookForm from "../components/AddBookForm";
import Header from "../components/Header";


const AddBook = () =>{
    return(
        <div>
            <Header />
            <AddBookForm />
            
        </div>

    )
}
export default AddBook;